export const isValidPassword = (password) => {
  const passwordRegex =
    /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_\-+=])[A-Za-z0-9!@#$%^&*()_\-+=]{8,}$/;
  return passwordRegex.test(password);
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
};

export const isValidDate = (dateString) => {
  const dateObject = new Date(dateString);
  return (
    !isNaN(dateObject.getTime()) &&
    dateObject.toISOString().slice(0, 10) === dateString
  );
};

export const isValidPhoneNumber = (phoneNumber) => {
  var phoneRegex = /^\d{10}$/;
  return phoneRegex.test(phoneNumber);
};

export const isEmpty = (value) => {
  // Controllo per `null` o `undefined`
  if (value === null || value === undefined) {
    return true;
  }

  // Controllo per stringhe vuote
  if (typeof value === "string" && value.trim().length === 0) {
    return true;
  }

  // Controllo per array vuoti
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }

  // Controllo per oggetti vuoti
  if (typeof value === "object" && Object.keys(value).length === 0) {
    return true;
  }

  // Controllo per Map e Set vuoti
  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }

  // Controllo per numeri NaN
  if (typeof value === "number" && isNaN(value)) {
    return true;
  }

  return false;
};

const isValidBase64 = (str) => {
  return /^[A-Za-z0-9+/=]+$/.test(str);
};

// Converte un'immagine base64 in un Blob (necessario per l'invio a Multer)
export const base64ToBlob = (base64String) => {
  // Verifica se la stringa base64 include un prefisso del tipo (data:[type];base64,)
  const match = base64String.match(/^data:(.*?);base64,/);
  if (!match) {
    console.log("Invalid base64 string format");
    throw new Error("Invalid base64 string format");
  }

  // Estrae il tipo MIME dalla stringa
  const mimeType = match[1];

  // Estrae la parte base64 dei dati
  const base64Data = base64String.split(",")[1];

  if (!isValidBase64(base64Data)) {
    console.log("Invalid base64 string");
    throw new Error("Invalid base64 string");
  }

  // Decodifica la stringa base64
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length)
    .fill()
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  // Crea e restituisce un Blob con il tipo MIME dinamico
  return new Blob([byteArray], { type: mimeType });
};
